/**
 * Format a Date object as "YYYY-MM-DD" in UTC.
 * We use UTC date because the date does not have to be exact and it allows us to prevent the hydration mismatches
 * caused by users' browsers having different timezones than the server.
 */
export function formatYMD(d: Date): string {
  const year = d.getUTCFullYear();
  const month = (d.getUTCMonth() + 1).toString().padStart(2, "0");
  const day = d.getUTCDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
}
